export const getCookie = (cookieName: string) => {
    const { cookie } = document;

    if (cookie && cookieName) {
        const i = cookie.indexOf(`${cookieName}=`);

        if (i > -1) {
            const j = cookie.indexOf(";", i);
            return cookie.substring(i + cookieName.length + 1, j < 0 ? cookie.length : j);
        }
    }
    return null;
};

export const setCookie = (cookieName: string, cookieValue: string, expiration?: Date): void => {
    let expires = "";

    if (expiration !== undefined && expiration !== null) {
        expires = `; expires=${expiration.toUTCString()}`;
    }

    document.cookie = `${cookieName}=${cookieValue}${expires}; path=/`;
};

export const deleteCookie = (cookieName: string): void => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};
